import React from 'react';
import ContentLoader from 'react-content-loader';

interface IProps {
  width?: string;
  height?: string;
}

const LineSkeleton: React.FC<IProps> = ({ width, height }) => {
  const defaultStyle = {
    marginBottom: '16px',
  };

  return (
    <div style={defaultStyle}>
      <ContentLoader
        speed={2}
        width="100%"
        height={20}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
      >
        <rect x="0" y="0" rx="3" ry="3" width={width} height={height || '20'} />
      </ContentLoader>
    </div>
  );
};

export default LineSkeleton;
